/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './diag-lab-inventory.reducer';

export const DiagLabInventory = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const diagLabInventoryList = useAppSelector(state => state.diagLabInventory.entities);
  const loading = useAppSelector(state => state.diagLabInventory.loading);
  const totalItems = useAppSelector(state => state.diagLabInventory.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="diag-lab-inventory-heading" data-cy="DiagLabInventoryHeading">
        <Translate contentKey="tinyMedicRestApp.diagLabInventory.home.title">Diag Lab Inventories</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.diagLabInventory.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/diag-lab-inventory/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.diagLabInventory.home.createLabel">Create new Diag Lab Inventory</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.diagLabInventory.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {diagLabInventoryList && diagLabInventoryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('brandId')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.brandId">Brand Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('brandId')} />
                </th>
                <th className="hand" onClick={sort('batchNumber')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.batchNumber">Batch Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('batchNumber')} />
                </th>
                <th className="hand" onClick={sort('serialNumber')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.serialNumber">Serial Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('serialNumber')} />
                </th>
                <th className="hand" onClick={sort('stockQty')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.stockQty">Stock Qty</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('stockQty')} />
                </th>
                <th className="hand" onClick={sort('manufacDate')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.manufacDate">Manufac Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('manufacDate')} />
                </th>
                <th className="hand" onClick={sort('expDate')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.expDate">Exp Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('expDate')} />
                </th>
                <th className="hand" onClick={sort('taxCode')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.taxCode">Tax Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('taxCode')} />
                </th>
                <th className="hand" onClick={sort('mrp')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.mrp">Mrp</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mrp')} />
                </th>
                <th className="hand" onClick={sort('price')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.price">Price</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('price')} />
                </th>
                <th className="hand" onClick={sort('remainingQuantity')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.remainingQuantity">Remaining Quantity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('remainingQuantity')} />
                </th>
                <th className="hand" onClick={sort('avgUsesPerItem')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.avgUsesPerItem">Avg Uses Per Item</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('avgUsesPerItem')} />
                </th>
                <th className="hand" onClick={sort('packs')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.packs">Packs</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('packs')} />
                </th>
                <th className="hand" onClick={sort('HSNCode')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.HSNCode">HSN Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('HSNCode')} />
                </th>
                <th className="hand" onClick={sort('rack')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.rack">Rack</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rack')} />
                </th>
                <th className="hand" onClick={sort('discount')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.discount">Discount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discount')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.diagLab">Diag Lab</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.type">Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.diagLabInventory.bill">Bill</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {diagLabInventoryList.map((diagLabInventory, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/diag-lab-inventory/${diagLabInventory.id}`} color="link" size="sm">
                      {diagLabInventory.id}
                    </Button>
                  </td>
                  <td>{diagLabInventory.brandId}</td>
                  <td>{diagLabInventory.batchNumber}</td>
                  <td>{diagLabInventory.serialNumber}</td>
                  <td>{diagLabInventory.stockQty}</td>
                  <td>{diagLabInventory.manufacDate}</td>
                  <td>{diagLabInventory.expDate}</td>
                  <td>{diagLabInventory.taxCode}</td>
                  <td>{diagLabInventory.mrp}</td>
                  <td>{diagLabInventory.price}</td>
                  <td>{diagLabInventory.remainingQuantity}</td>
                  <td>{diagLabInventory.avgUsesPerItem}</td>
                  <td>{diagLabInventory.packs}</td>
                  <td>{diagLabInventory.HSNCode}</td>
                  <td>{diagLabInventory.rack}</td>
                  <td>{diagLabInventory.discount}</td>
                  <td>{diagLabInventory.active ? 'true' : 'false'}</td>
                  <td>{diagLabInventory.cursor}</td>
                  <td>{diagLabInventory.lastUpdated}</td>
                  <td>{diagLabInventory.microSec}</td>
                  <td>{diagLabInventory.timestampEntry}</td>
                  <td>
                    {diagLabInventory.diagLab ? (
                      <Link to={`/diag-lab/${diagLabInventory.diagLab.id}`}>{diagLabInventory.diagLab.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {diagLabInventory.type ? (
                      <Link to={`/diag-lab-inventory-type/${diagLabInventory.type.id}`}>{diagLabInventory.type.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {diagLabInventory.bill ? (
                      <Link to={`/diag-lab-inventory-bill/${diagLabInventory.bill.id}`}>{diagLabInventory.bill.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/diag-lab-inventory/${diagLabInventory.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/diag-lab-inventory/${diagLabInventory.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/diag-lab-inventory/${diagLabInventory.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.diagLabInventory.home.notFound">No Diag Lab Inventories found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={diagLabInventoryList && diagLabInventoryList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DiagLabInventory;
